export default angular.module('eventix.shop.tickets.directives',[])
    .directive('countdown', function($interval, $translate, $timeout) {
        /**
         * Directive that shows a flexible countdown
         *
         * X weeks/days/hours or 2:35
         *
         * @param {String} time Timestring to countdown to
         * @param {String} [format=YYYY-MM-DDTHH:mm:ssZ] Optional time format
         * @param {Function} expires A function to execute when countdown reaches 0
         */
        return {
            restrict: 'E',
            link: function(scope, el, attr) {
                scope.intervalTime = null;
                var updateInterval;
                var countdownTo;
                var ISO8601 = 'YYYY-MM-DDTHH:mm:ssZ';
                const duration = {
                    week: 7 * 24 * 60 * 60,
                    day: 24 * 60 * 60,
                    hour: 60 * 60,
                    minute: 60
                };
                scope.$on('$destroy', () => $interval.cancel(updateInterval));
                scope.$watch(attr.time, _.throttle(function(t) {
                    let format = scope.$eval(attr.format) || ISO8601;
                    let now = moment();
                    countdownTo = moment(t, format);
                    let diff = countdownTo.diff(now, 'seconds');
                    setContent(diff);
                }, 1000));

                scope.$watch('intervalTime', function(time) {
                    $interval.cancel(updateInterval);
                    if (time !== null) {
                        updateInterval = $interval(() => {
                            let now = moment();
                            let diff = countdownTo.diff(now, 'seconds');
                            setContent(diff);
                        }, time);
                    } else
                        $timeout(() => scope.$eval(attr.expired), 100);
                });

                /**
                 * Set inner content with correct label X days/hours
                 *
                 * @param {Integer} diff Between now and countdownTo in seconds
                 */
                function setContent(diff) {
                    if (diff > duration.week) {
                        el[0].innerText = [
                            Math.round(diff / duration.week),
                            _.toLower($translate.instant('common.datetime.week_plural'))
                        ].join(' ');
                        scope.intervalTime = 30 * 1000;
                    } else if (diff > duration.day) {
                        el[0].innerText = [
                            Math.round(diff / duration.day),
                            _.toLower($translate.instant('common.datetime.day_plural'))
                        ].join(' ');
                        scope.intervalTime = 30 * 1000;
                    } else if (diff > 2 * duration.hour) {
                        el[0].innerText = [
                            Math.round(diff / duration.hour),
                            _.toLower($translate.instant('common.datetime.hours'))
                        ].join(' ');
                        scope.intervalTime = 30 * 1000;
                    } else if (diff > 5 * duration.minute) {
                        el[0].innerText = [
                            Math.round(diff / duration.minute),
                            _.toLower($translate.instant('common.datetime.minutes'))
                        ].join(' ');
                        scope.intervalTime = 10 * 1000;
                    } else if (diff > 0) {
                        el[0].innerText = [
                            Math.max(0, Math.floor(diff / 60)),
                            ('0' + Math.max(diff % 60, 0)).substr(-2)
                        ].join(':');
                        scope.intervalTime = 1000;
                    } else {
                        el[0].html = '';
                        scope.intervalTime = null;
                    }
                }
            }
        };
    })
    .directive('reservationSummary', function(Locales, Currencies) {
        return {
            restrict: 'E',
            replace: true,
            template: `<div class="ticket-cost col-xs-3">
    <span class="sum" ng-show="(priceQuantities | lodash:'keys').length <= 2">
        {{ priceQuantities[currentPrice] }} &times;
        <exchange-currency  convert-to="currencies.selected" locale="locales.selected"
            amount="currentPrice" convert-from="shop.currency" ng-class="{'text-danger': currentPrice != ticket.minimumPrice }"></exchange-currency>
        <span class="other-price" ng-repeat="(price, quantity) in priceQuantities" ng-hide="price == currentPrice">
            {{ quantity }} &times;
            <exchange-currency convert-to="currencies.selected" locale="locales.selected"
                amount="price" convert-from="shop.currency" ng-class="{'text-danger': price != ticket.minimumPrice && coupon, 'strike-out': quantity == 0 }"></exchange-currency>
        </span>
    </span>
    <span class="sum" ng-show="(priceQuantities | lodash:'keys').length > 2">
        {{ priceQuantities[currentPrice] }} &times;
        <exchange-currency convert-to="currencies.selected" locale="locales.selected"
            amount="currentPrice" convert-from="shop.currency" ng-class="{'text-danger': currentPrice != ticket.minimumPrice }"></exchange-currency>
        <span class="other-price">
            {{ reservations.length - priceQuantities[currentPrice] }} &times; &hellip;
        </span>
    </span>
    <span class="total">
        <exchange-currency convert-to="currencies.selected" locale="locales.selected"
            amount="total" convert-from="shop.currency"></exchange-currency>
    </span>
</div>`,
            scope: {
                ticket: '=',
                reservations: '=',
                shop: '=',
                coupon: '='
            },
            link: function(scope, el, attr) {
                scope.currentPrice = scope.ticket.discountPrice || scope.ticket.minimumPrice;
                scope.priceQuantities = {};
                scope.priceQuantities[scope.currentPrice] = 0;
                scope.total = 0;
                scope.currentPrice = 0;

                scope.currencies = Currencies;
                scope.locales = Locales;

                scope.$watch('ticket', ticket => {
                    if(!ticket) return;
                    scope.currentPrice = (typeof ticket.discountPrice === 'undefined' ? ticket.minimumPrice : ticket.discountPrice);
                    if(!_.has(scope.priceQuantities, scope.currentPrice))
                        scope.priceQuantities[scope.currentPrice] = 0;
                }, true);

                scope.$watch('reservations', reservations => {
                    if(scope.ticket)
                        scope.currentPrice = scope.ticket.discountPrice || scope.ticket.minimumPrice;
                    scope.priceQuantities = {};
                    scope.priceQuantities[scope.currentPrice] = 0;
                    scope.total = 0;

                    if(!reservations || reservations.length === 0)
                        return;

                    let substractAmountForDisplay = 0;
                    if(scope.currentPrice !== 0 && !scope.ticket.include_service_cost_in_price){
                        let varying = scope.currentPrice * scope.ticket.service_cost_percentage;
                        substractAmountForDisplay = scope.ticket.service_cost + varying;
                    }

                    let sorted = _.groupBy(reservations, r => Math.round(r.price - substractAmountForDisplay));
                    let prices = _.keys(sorted);
                    _.forEach(sorted, (reservations, price) => {
                        if(!_.has(scope.priceQuantities, 'price'))
                            scope.priceQuantities[price] = 0;
                        scope.priceQuantities[price] += reservations.length;
                    });
                    scope.total = _.sumBy(reservations, r => Math.round(r.price - substractAmountForDisplay));
                }, true);
            }
        };
    })
    .name;
